<style scoped lang="scss">
.main {
  display: flex;
  flex-flow: row;
  .nav-wrap {
    position: relative;
    margin: 14px 20px 0 0;
    width: 155px;
  }
}
</style>

<template>
  <div class="main">
    <div class="nav-wrap">
      <nav-bar :routers="routers"></nav-bar>
    </div>

    <router-view :grade-id="gradeId" :subject-list="mainSubjectList" :school-id="schoolId"></router-view>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import { baseData } from "@/v2/utils/data";

export default {
  props: ['gradeId', 'subjectList', 'schoolId'],

  data () {
    return {
      routers: [{
        path: "/exam/gaokao/report/" + this.$route.params.id + "/subject/basic",
        name: "基础成绩分析"
      },
      {
        path: "/exam/gaokao/report/" + this.$route.params.id + "/subject/scoreSection",
        name: "分数段占比"
      }],
    }
  },

  computed: {
    mainSubjectList () {
      return this.subjectList.filter(item => {
        const subjectId = baseData.getSubjectIdByCourseId(item.subjectCode)
        return ['1', '2', '3'].find(row => row === subjectId)
      })
    }
  },

  components: {
    NavBar
  }
};
</script>
